// Sidebar.jsx
import React from "react";
import { AccountToggle } from "./AccountToggle";
import { Link, useLocation } from "react-router-dom";
import roket from "./../../images/rocket.png";

export const Sidebar = () => {
  const location = useLocation();
  return (
    <div className="w-75 h-screen px-6 py-6 flex flex-col border-r border-black/10 ">
      <AccountToggle />

      {/* Navigation Buttons */}
      <div className="mt-6 flex flex-col gap-3">
        <h1 className="uppercase pl-3 text-[13px] font-normal ">Home</h1>
        <Link
          to="/dashboard"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/dashboard")
              ? "bg-blue text-white"
              : "text-black hover:text-white hover:bg-blue"
          } rounded-lg hover:bg-blue py-3 px-4 mb-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] icon icon-tabler icon-tabler-layout-dashboard iconClass"
          >
            {" "}
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
            <path d="M4 4h6v8h-6z"></path> <path d="M4 16h6v4h-6z"></path>{" "}
            <path d="M14 12h6v8h-6z"></path> <path d="M14 4h6v4h-6z"></path>{" "}
          </svg>
          Dashboard
        </Link>
        <h1 className="uppercase pl-3 text-[13px] font-normal">Events</h1>
        <Link
          to="/events"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/events") ||
            location.pathname.includes("/events/create") ||
            location.pathname.includes("/events/update")
              ? "bg-blue text-white"
              : "text-black hover:text-white hover:bg-blue"
          } rounded-lg hover:bg-blue  py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] icon icon-tabler icon-tabler-versions iconClass"
          >
            {" "}
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
            <rect x="10" y="5" width="10" height="14" rx="2"></rect>{" "}
            <line x1="7" y1="7" x2="7" y2="17"></line>{" "}
            <line x1="4" y1="8" x2="4" y2="16"></line>{" "}
          </svg>
          Events
        </Link>
        <Link
          to="/delegates"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/delegates")
              ? "bg-blue text-white"
              : "text-black hover:text-white hover:bg-blue"
          } rounded-lg hover:bg-blue  py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] icon icon-tabler icon-tabler-users iconClass"
          >
            {" "}
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
            <circle cx="9" cy="7" r="4"></circle>{" "}
            <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>{" "}
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>{" "}
            <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>{" "}
          </svg>
          Delegates
        </Link>
        <Link
          to="/excels"
          className={`px-4 py-2 flex ${
            location.pathname.includes("/excels")
              ? "bg-blue text-white"
              : "text-black hover:text-white hover:bg-blue"
          } rounded-lg hover:bg-blue  py-3 px-4 `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-[10px] icon icon-tabler icon-tabler-file-spreadsheet iconClass"
          >
            {" "}
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
            <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>{" "}
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>{" "}
            <path d="M8 11h8v7h-8z"></path> <path d="M8 15h8"></path>{" "}
            <path d="M11 11v7"></path>{" "}
          </svg>
          Excels
        </Link>

        <div className="w-full mt-10 ">
          <div className="w-full flex items-center justify-center gap-4 rounded-md py-6 px-3 bg-bg-light ">
            <p className="font-medium text-[18px] ">
              TEF <br /> Go{" "}
            </p>
            <img
              src={roket}
              alt="roket"
              className="mt-[-35px] object-contain "
            />
          </div>
        </div>
      </div>
    </div>
  );
};
